let currentCategory = 'ALL';
let currentBrand = 'ALL';

// -----------------------------------------------
// カテゴリフィルター（ストーリーアイコンクリック）
// -----------------------------------------------
function filterByCategory(categoryName) {
  currentCategory = categoryName;
  currentBrand = 'ALL'; // カテゴリ変更時はブランドをリセット

  // ストーリーアイコンのアクティブ状態更新
  document.querySelectorAll('.story-item').forEach(item => {
    const cat = item.getAttribute('onclick')?.match(/filterByCategory\('(.+?)'\)/)?.[1];
    item.classList.toggle('is-active', cat === categoryName);
  });

  // ブランドフィルタートリガーのテキストをリセット
  const trigger = document.getElementById('brandFilterTriggerText');
  if (trigger) trigger.textContent = 'ブランドで絞り込む';

  filterGrid();
}

// -----------------------------------------------
// グリッド絞り込み（カテゴリ＋ブランドのAND条件）
// -----------------------------------------------
function filterGrid() {
  const cards = document.querySelectorAll('#masonryGrid .card');
  cards.forEach(card => {
    const cardTag   = card.dataset.tag   || '';
    const cardBrand = card.dataset.brand || '';

    const categoryMatch = currentCategory === 'ALL' || cardTag === currentCategory;
    const brandMatch    = currentBrand    === 'ALL' || cardBrand === currentBrand;

    card.style.display = (categoryMatch && brandMatch) ? '' : 'none';
  });

  // ブランドシートの一覧も現在のカテゴリに合わせて更新
  renderBrandSheetList();
}

// -----------------------------------------------
// ブランドボトムシート 開閉
// -----------------------------------------------
function openBrandSheet() {
  renderBrandSheetList();
  document.getElementById('brandSheetOverlay')?.classList.add('is-open');
  document.getElementById('brandSheetPanel')?.classList.add('is-open');
}

function closeBrandSheet() {
  document.getElementById('brandSheetOverlay')?.classList.remove('is-open');
  document.getElementById('brandSheetPanel')?.classList.remove('is-open');
}

// -----------------------------------------------
// ブランド一覧を現在のカテゴリで絞って描画
// -----------------------------------------------
function renderBrandSheetList() {
  const cards = document.querySelectorAll('#masonryGrid .card');
  const brands = new Set();

  cards.forEach(card => {
    const cardTag   = card.dataset.tag   || '';
    const cardBrand = card.dataset.brand || '';
    // 現在のカテゴリに属するカードのブランドのみ収集
    if (currentCategory === 'ALL' || cardTag === currentCategory) {
      if (cardBrand) brands.add(cardBrand);
    }
  });

  const list = document.getElementById('brandSheetList');
  if (!list) return;

  let html = `<button class="brand-sheet-item${currentBrand === 'ALL' ? ' is-active' : ''}" data-brand="ALL" onclick="selectBrandFilter('ALL')">すべてのブランド</button>`;
  [...brands].sort().forEach(brand => {
    const active = currentBrand === brand ? ' is-active' : '';
    html += `<button class="brand-sheet-item${active}" data-brand="${brand}" onclick="selectBrandFilter('${brand}')">${brand}</button>`;
  });
  list.innerHTML = html;
}

// -----------------------------------------------
// ブランド選択
// -----------------------------------------------
function selectBrandFilter(brand) {
  currentBrand = brand;

  // トリガーテキスト更新
  const trigger = document.getElementById('brandFilterTriggerText');
  if (trigger) trigger.textContent = brand === 'ALL' ? 'ブランドで絞り込む' : brand;

  filterGrid();
  closeBrandSheet();
}

// -----------------------------------------------
// ブランドシート内のアクティブ状態更新（互換用）
// -----------------------------------------------
function updateBrandFilterUI() {
  document.querySelectorAll('#brandSheetList .brand-sheet-item').forEach(btn => {
    btn.classList.toggle('is-active', btn.dataset.brand === currentBrand);
  });
}

// -----------------------------------------------
// スライダー関数（未定義の場合のみ定義）
// -----------------------------------------------
if (typeof wwjfSliderMove === 'undefined') {
  window.wwjfSliderMove = function(secId, dir) {
    var track = document.getElementById('wwjf-pc-track-' + secId);
    if (!track) return;
    var card = track.querySelector('.story-item, .wwjf-pc__slide-card');
    var cardW = card ? card.offsetWidth + 16 : 96;
    track.scrollBy({ left: dir * cardW * 3, behavior: 'smooth' });
    setTimeout(function() { wwjfArrowUpdate(secId); }, 400);
  };
}

if (typeof wwjfArrowUpdate === 'undefined') {
  window.wwjfArrowUpdate = function(secId) {
    var track = document.getElementById('wwjf-pc-track-' + secId);
    var outer = document.getElementById('wwjf-pc-slider-' + secId);
    if (!track || !outer) return;
    var prev = outer.querySelector('.wwjf-pc__arrow--prev');
    var next = outer.querySelector('.wwjf-pc__arrow--next');
    if (prev) prev.classList.toggle('is-hidden', track.scrollLeft <= 0);
    if (next) next.classList.toggle('is-hidden',
      track.scrollLeft + track.clientWidth >= track.scrollWidth - 2);
  };
}

if (typeof wwjfInitDrag === 'undefined') {
  window.wwjfInitDrag = function(secId) {
    var track = document.getElementById('wwjf-pc-track-' + secId);
    if (!track) return;
    var isDown = false, startX, scrollLeft;

    track.addEventListener('mousedown', function(e) {
      isDown = true;
      track.classList.add('is-dragging');
      startX = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
    });
    document.addEventListener('mouseup', function() {
      isDown = false;
      track.classList.remove('is-dragging');
      wwjfArrowUpdate(secId);
    });
    track.addEventListener('mousemove', function(e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - track.offsetLeft;
      track.scrollLeft = scrollLeft - (x - startX);
    });
    track.addEventListener('scroll', function() {
      wwjfArrowUpdate(secId);
    });

    var touchStartX, touchScrollLeft;
    track.addEventListener('touchstart', function(e) {
      touchStartX = e.touches[0].pageX;
      touchScrollLeft = track.scrollLeft;
    }, { passive: true });
    track.addEventListener('touchmove', function(e) {
      var dx = touchStartX - e.touches[0].pageX;
      track.scrollLeft = touchScrollLeft + dx;
    }, { passive: true });
    track.addEventListener('touchend', function() {
      wwjfArrowUpdate(secId);
    });

    wwjfArrowUpdate(secId);
  };
}
